export default {
    CREATE_CUSTOM_FIELD: () => '/customField',
    GET_ALL_CUSTOM_FIELD: () => '/customField',
    UPDATE_CUSTOM_FIELD: (id) => `/customField/${id}`,
    DELETE_PROPERTY: (id) => `/CustomProperty/${id}`,
    GET_CUSTOM_FIELD_BY_ID: (id) => `/customField/${id}`,

    GET_CUSTOM_FIELD_BY_TASK_ID: (id) => `/customField/task/${id}`,
    DELETE_CUSTOEM_FILED: (id) => `/customField/${id}`,
    DELETE_CUSTOEM_FILED_BY_TAG: () => `/customField/tag`,
};
